import { useNavigate, useLocation } from "react-router-dom";
import BasketIcon from "../../../assets/icons/BasketIcon";
import CatalogIcon from "../../../assets/icons/CatalogIcon";
import FavoriteIcon from "../../../assets/icons/FavoriteIcon";
import HomeIcon from "../../../assets/icons/HomeIcon";
import UserIcon from "../../../assets/icons/UserIcon";
import SearchInput from "../../input/SearchInput";
// import HeaderWarehouseInfo from "../../warehouse/HeaderWarehouseInfo";
import { useState } from "react";
import HamburgerMenu from "../../menu/HamburgerMenu";
import { useProductStore } from "../../../store/productStore";
import { useCartStore } from "../../../store/cartStore";
import HamburgerMenuMobile from "../../menu/HamburgerMenuMobile";

function HeaderMobile() {
    const navigate = useNavigate();
    const location = useLocation(); // Получаем текущий путь
    const { resetFilters } = useProductStore();
    const [menuOpen, setMenuOpen] = useState(false);

    // Товары корзины
    const { items } = useCartStore();
    // Считаем количество
    const cartCount = items.reduce((total, item) => total + (item.quantity || 0), 0);

    const handleLogoClick = () => {
        navigate("/", { replace: true });
        setTimeout(() => resetFilters(), 1000);
        closeMenu();
    };

    const toggleMenu = () => {
        setMenuOpen((prev) => !prev);
    };

    const closeMenu = () => setMenuOpen(false);

    const handleProfileClick = () => {navigate("/profile"); closeMenu();};
    const handleFavoritesClick = () => {navigate("/favorites"); closeMenu();}; 
    const handleCartClick = () => {navigate("/cart"); closeMenu();};

    // Функция для определения активного цвета
    const getIconColor = (path: string) =>
        location.pathname === path ? "#FC8181" : "#1E1E1E"; // Розовый для активной, черный для неактивной

    return (
        <>
            <div className="container mx-auto md:hidden p-4 flex flex-row space-x-4 justify-between items-center">
                <SearchInput placeholder="Поиск..." />
                {/* <HeaderWarehouseInfo /> */}
            </div>

            <footer className="fixed bottom-0 w-full md:hidden bg-white flex justify-around py-2 border-t z-50">
                <button onClick={handleLogoClick} className="flex flex-col items-center">
                    <div className="flex items-center justify-center w-6 h-6">
                        <HomeIcon isActive={location.pathname === "/"} />
                    </div>
                    <span className="text-xs" style={{ color: getIconColor("/") }}>Главная</span>
                </button>
                <button onClick={toggleMenu} className="flex flex-col items-center">
                    <div className="flex items-center justify-center w-6 h-6">
                        <CatalogIcon className="w-6 h-6" isActive={location.pathname === "/catalog" || menuOpen} />
                    </div>
                    <span className="text-xs" style={{ color: getIconColor("/catalog") }}>Каталог</span>
                </button>
                <button onClick={handleFavoritesClick} className="flex flex-col items-center">
                    <div className="flex items-center justify-center w-6 h-6">
                        <FavoriteIcon className="w-6 h-6" isActive={location.pathname === "/favorites"} />
                    </div>
                    <span className="text-xs" style={{ color: getIconColor("/favorites") }}>Избранное</span>
                </button>
                <button onClick={handleCartClick} className="flex flex-col items-center">
                    <div className="flex items-center justify-center w-6 h-6">
                        <BasketIcon className="w-6 h-6" isEmpty={cartCount === 0} isActive={location.pathname === "/cart"} />
                    </div>
                    <span className="text-xs" style={{ color: getIconColor("/cart") }}>Корзина</span>
                </button>
                <button onClick={handleProfileClick} className="flex flex-col items-center">
                    <div className="flex items-center justify-center w-6 h-6">
                        <UserIcon className="w-6 h-6" isActive={location.pathname === "/profile" || location.pathname === "/auth"} />
                    </div>
                    <span className="text-xs" style={{ color: location.pathname === "/profile" || location.pathname === "/auth" ? "#FC8181" : "#1E1E1E" }}>Профиль</span>
                </button>
            </footer>

            {menuOpen && <HamburgerMenuMobile onClose={closeMenu} isMobile={true} />}
        </>
    );
}

export default HeaderMobile;